/**
 * Mounts at the App.js root inside the Router. Listens for SPA route
 * changes and fires Meta Pixel PageView. The initial PageView is fired
 * by the inline pixel snippet in public/index.html; THIS hook handles
 * subsequent navigations only (skips first render to avoid double-fire).
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/metaPixel";

export default function PixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      // Initial PageView is already fired by the inline pixel JS in
      // public/index.html — don't double-fire.
      isFirstRender.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname]);

  return null;
}
